import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsArray, IsOptional, IsString, ValidateNested } from 'class-validator';
import { ContractorUserCreateDto } from './contractor-user-create.dto';
import { ContractorUserInterface } from '../interfaces/contractor-user.interface';
import { ContractorUserBatchInterface } from '../interfaces/contractor-user-batch.interface';

export class ContractorUserBatchDto implements ContractorUserBatchInterface {
  @ApiPropertyOptional({
    type: () => ContractorUserCreateDto,
    title: 'ContractorUser',
    nullable: true,
    isArray: true,
    description: 'Insert bulk',
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => ContractorUserCreateDto)
  insert!: ContractorUserCreateDto[];

  @ApiProperty({
    type: () => String,
    nullable: true,
    isArray: true,
    title: 'Delete Bulk',
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  delete!: ContractorUserInterface['id'][];
}
